<template>
  <PreviewElementWrapper 
    :initial-selected="isSelected"
    :elementType="element.type"
    :element="element" 
    :selectedPreviewId="selectedPreviewId"
    :disabled="disabled"
    @select-change="handleSelectChange"
    @update-element-data="$emit('update-element-data', $event)"
    @auto-mapping="$emit('auto-mapping', element.id)"
    @element-edit-state-changed="$emit('element-edit-state-changed', $event)"
  >
    <div class="signature-area">
      <div class="signature-placeholder">
        <span class="placeholder-text">Sign Area</span>
      </div>
    </div>
  </PreviewElementWrapper>
</template>

<script>
import PreviewElementWrapper from './PreviewElementWrapper.vue';

export default {
  name: 'SignerPreview',
  components: { PreviewElementWrapper },
  props: {
    element: { type: Object, default: () => ({}) },
    selectedPreviewId: { type: String, default: '' },
    disabled: { type: Boolean, default: false }
  },
  data() {
    return {
      isSelected: false
    };
  },
  emits: [
    'auto-mapping',
    'update-element-data',
    'element-edit-state-changed'
  ],
  methods: {
    handleSelectChange(selected) {
      this.isSelected = selected;
    }
  }
};
</script>

<style scoped>
.signature-area {
  padding: 4px 24px;
  height: 92px;
  box-sizing: border-box;
}

.signature-placeholder {
  width: 100%;
  height: 100%;
  border-radius: 5px;
  border: 2px dashed #C4C4C4;
  background: #F2F2F2;
  display: flex;
  align-items: center;
  justify-content: center;
}

.placeholder-text {
  font-family: 'Inter', sans-serif;
  color: #999;
  font-size: 24px;
  font-style: italic;
  font-weight: 400;
  line-height: 36px;
}

</style>
